<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import SubscribeView from '../../../../../billing/components/SubscribeView.vue'

definePage({
  props: true,
  meta: {
    requiresAuth: true,
    requiresOrganisation: true,
    hideLeftColumn: true,
    hideRightColumn: true,
    featureFlags: 'subscription',
  },
})
</script>

<template>
  <SubscribeView />
</template>
